module.exports = __webpack_public_path__ + "static/media/carousel-02.fbc6c2fd.jpg";